(function() {
  const LOCAL_STORAGE_KEY = 'tuya-wishlist';
  
  const SELECTORS = {
    wishlistButtons: '.tuya-product-card__wishlist, .tuya-product-catalog__wishlist, .tuya-product-title__wishlist',
    wishlistGrid: '.tuya-wishlist__grid',
    wishlistItem: '.tuya-wishlist__item',
    wishlistLoading: '.tuya-wishlist__loading',
    wishlistEmpty: '.tuya-wishlist__empty',
    desktopBadges: '.tuya-header__badge--wishlist',
    mobileBadges: '.tuya-header__cart-count--wishlist'
  };

  const TuyaWishlist = {
    get() {
      try {
        const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
        return stored ? JSON.parse(stored) : [];
      } catch (e) {
        console.error('Error parsing wishlist from localStorage:', e);
        return [];
      }
    },

    save(wishlist) {
      try {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(wishlist));
        document.dispatchEvent(new CustomEvent('wishlist:updated', {
          detail: { wishlist }
        }));
      } catch (e) {
        console.error('Error saving wishlist to localStorage:', e);
      }
    },

    add(handle) {
      if (!handle) return;
      const wishlist = this.get();
      if (!wishlist.includes(handle)) {
        wishlist.push(handle);
        this.save(wishlist);
      }
    },

    remove(handle) {
      if (!handle) return;
      const wishlist = this.get();
      const updatedWishlist = wishlist.filter(h => h !== handle);
      if (wishlist.length !== updatedWishlist.length) {
        this.save(updatedWishlist);
      }
    },

    toggle(handle) {
      if (!handle) return;
      const wishlist = this.get();
      if (wishlist.includes(handle)) {
        this.remove(handle);
      } else {
        wishlist.push(handle);
        this.save(wishlist);
      }
    },

    has(handle) {
      if (!handle) return false;
      return this.get().includes(handle);
    },

    updateButtonsState(wishlist) {
      const currentWishlist = Array.isArray(wishlist) ? wishlist : this.get();
      const wishlistButtons = document.querySelectorAll(SELECTORS.wishlistButtons);

      wishlistButtons.forEach(button => {
        const handle = button.getAttribute('data-product-handle');
        const isActive = handle && currentWishlist.includes(handle);
        
        button.classList.toggle('active', !!isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    },

    updateHeaderBadges(wishlist) {
      const currentWishlist = Array.isArray(wishlist) ? wishlist : this.get();
      const count = currentWishlist.length;

      const desktopBadges = document.querySelectorAll(SELECTORS.desktopBadges);
      const mobileBadges = document.querySelectorAll(SELECTORS.mobileBadges);

      const updateBadge = (badge) => {
        badge.textContent = count;
        badge.style.display = count > 0 ? 'flex' : 'none';
      };

      desktopBadges.forEach(updateBadge);
      mobileBadges.forEach(updateBadge);
    },

    updateWishlistPage(wishlist) {
      const gridEl = document.querySelector(SELECTORS.wishlistGrid);
      if (!gridEl) return;

      const section = gridEl.closest('.tuya-wishlist');
      const loadingEl = section?.querySelector(SELECTORS.wishlistLoading);
      const emptyEl = section?.querySelector(SELECTORS.wishlistEmpty);

      const currentWishlist = Array.isArray(wishlist) ? wishlist : this.get();
      let visibleCount = 0;

      gridEl.querySelectorAll(SELECTORS.wishlistItem).forEach(item => {
        const handle = item.getAttribute('data-product-handle');
        const isVisible = handle && currentWishlist.includes(handle);
        
        if (isVisible) {
          if (item.style.display !== 'block') {
            item.style.display = 'block';
            item.classList.add('is-revealing');
          }
          item.style.order = currentWishlist.indexOf(handle);
          visibleCount++;
        } else {
          item.style.display = 'none';
          item.classList.remove('is-revealing');
          item.style.order = '';
        }
      });

      if (loadingEl) loadingEl.style.display = 'none';
      if (emptyEl) emptyEl.style.display = visibleCount === 0 ? 'flex' : 'none';
      gridEl.style.display = visibleCount === 0 ? 'none' : 'grid';
      if (section) {
        section.classList.toggle('is-empty', visibleCount === 0);
      }
    },

    refresh(wishlist) {
      const list = wishlist || this.get();
      this.updateButtonsState(list);
      this.updateHeaderBadges(list);
      this.updateWishlistPage(list);
    }
  };

  window.TuyaWishlist = TuyaWishlist;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest(SELECTORS.wishlistButtons);
    if (!btn) return;
    
    e.preventDefault();
    e.stopPropagation();

    const handle = btn.getAttribute('data-product-handle');
    if (handle) {
      TuyaWishlist.toggle(handle);
    }
  });

  document.addEventListener('wishlist:updated', (e) => {
    TuyaWishlist.refresh(e.detail?.wishlist);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => TuyaWishlist.refresh());
  } else {
    TuyaWishlist.refresh();
  }

  document.addEventListener('shopify:section:load', () => TuyaWishlist.refresh());
})();
